export const FORM_INPUT_STATES = {
  INPUT_VALIDATION_STATE_ERROR: 'error',
  INPUT_VALIDATION_STATE_WARNING: 'warning',
};
